import React from "react";
import { COLORS, TYPOGRAPHY, SPACING, SHADOWS, RADIUS, TRANSITIONS, GLASSMORPHISM } from '../constants/designTokens';

const advantages = [
    {
        icon: "fa-solid fa-globe",
        title: "Global Procurement Network",
        description:
            "Access to an extensive worldwide network of manufacturers, authorized distributors, and trusted suppliers across electrical, instrumentation & control, OWS/ODME, and fire & smoke detection, working with brands like Schneider, ABB, Siemens, WIKA, Danfoss, Deckma, and Consilium."
    },
    {
        icon: "fa-solid fa-truck-fast",
        title: "Fast Worldwide Distribution",
        description:
            "Expedited shipping to any port globally. Our logistics network ensures urgent spare parts reach your vessel within 24-72 hours, minimizing downtime and keeping your operations running smoothly."
    },
    {
        icon: "fa-solid fa-certificate",
        title: "Quality-Assured Parts",
        description:
            "Spare parts are sourced through trusted channels with supporting documentation, and selected to align with international maritime standards including SOLAS, IMO, and classification society requirements."
    },
    {
        icon: "fa-solid fa-headset",
        title: "Technical Expertise & Support",
        description:
            "Our specialized team has deep maritime industry knowledge to identify correct part numbers, suggest compatible alternatives, and provide technical guidance for installation and troubleshooting."
    }
];

const MarineSparesAdvantages = () => (
    <section
        id="advantages"
        className="services-section py-5"
        style={{
            background: COLORS.background.lightBlue,
            position: "relative",
        }}
    >
        <style>{`
            .services-section h2 {
                color: ${COLORS.primary.dark};
                font-weight: ${TYPOGRAPHY.fontWeight.bold};
                font-size: ${TYPOGRAPHY.fontSize['2xl']};
                margin-bottom: ${SPACING.md};
                text-align: center;
                line-height: ${TYPOGRAPHY.lineHeight.tight};
            }
            .services-section .section-subtitle {
                color: ${COLORS.text.primary};
                font-size: ${TYPOGRAPHY.fontSize.lg};
                text-align: center;
                max-width: 700px;
                margin: 0 auto ${SPACING['2xl']};
                line-height: ${TYPOGRAPHY.lineHeight.relaxed};
            }
            .service-card {
                margin-top: ${SPACING.md};
                background: ${COLORS.background.white};
                border-radius: ${RADIUS.xl};
                box-shadow: ${SHADOWS.sm};
                padding: ${SPACING.xl} ${SPACING.lg};
                transition: ${TRANSITIONS.all};
                height: 100%;
                margin-bottom: ${SPACING.md};
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                border: 1px solid ${COLORS.ui.border};
            }
            .service-card:hover {
                transform: translateY(-4px);
                box-shadow: ${SHADOWS.hover.lg};
                background: ${GLASSMORPHISM.light.background};
                backdrop-filter: blur(10px);
                -webkit-backdrop-filter: blur(10px);
                border-color: rgba(64, 168, 196, 0.3);
            }
            .service-icon {
                font-size: ${TYPOGRAPHY.fontSize['3xl']};
                color: ${COLORS.primary.teal};
                margin-bottom: ${SPACING.sm};
                transition: ${TRANSITIONS.transform};
            }
            .service-card:hover .service-icon {
                transform: scale(1.1);
            }
            .service-title {
                font-size: ${TYPOGRAPHY.fontSize.md};
                font-weight: ${TYPOGRAPHY.fontWeight.semibold};
                color: ${COLORS.primary.dark};
                margin-bottom: ${SPACING.sm};
                line-height: ${TYPOGRAPHY.lineHeight.tight};
            }
            .service-desc {
                color: ${COLORS.text.primary};
                font-size: ${TYPOGRAPHY.fontSize.sm};
                text-align: center;
                line-height: ${TYPOGRAPHY.lineHeight.relaxed};
            }
            @media (max-width: 991px) {
                .services-section h2 {
                    font-size: 1.8rem;
                }
                .services-section .section-subtitle {
                    font-size: 1rem;
                }
            }

            @media (max-width: 767.98px) {
                .services-section h2 {
                    font-size: ${TYPOGRAPHY.fontSize.xl};
                }
                .row {
                    display: flex;
                    flex-direction: column;
                    gap: ${SPACING.sm};
                }
                .col-md-6, .col-lg-3 {
                    max-width: 100%;
                    flex: 1 0 100%;
                    padding-left: 0;
                    padding-right: 0;
                }
                .service-card {
                    margin-top: ${SPACING.sm};
                    margin-bottom: ${SPACING.sm};
                    padding: ${SPACING.lg} ${SPACING.md};
                }
            }

            @media (max-width: 576px) {
                .service-card {
                    padding: 1.25rem 1rem;
                }
                .service-icon {
                    font-size: 2rem;
                }
            }
        `}</style>
        <div className="container">
            <h2>Why Choose Marine Sealink for Spare Parts?</h2>
            <p className="section-subtitle">
                With years of experience in maritime procurement and logistics, we deliver reliable spare parts solutions that keep your vessels operational and compliant.
            </p>
            <div className="row justify-content-center px-2 px-md-4 px-lg-5 stagger-container">
                {advantages.map((adv, idx) => (
                    <div className="col-md-6 col-lg-3 d-flex" key={idx}>
                        <div
                            className="service-card w-100 text-center scale-in animate-on-scroll"
                            style={{ '--stagger-index': idx }}
                        >
                            <i className={`${adv.icon} service-icon`}></i>
                            <div className="service-title">{adv.title}</div>
                            <div className="service-desc">{adv.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>

    </section>

);

export default MarineSparesAdvantages;
